import { render, staticRenderFns } from "./TranfserList.vue?vue&type=template&id=c091850a&"
import script from "./TranfserList.vue?vue&type=script&lang=js&"
export * from "./TranfserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports